export default "__VITE_ASSET__DnT76nso__"